export default __webpack_public_path__ + "static/media/etc06.23b0b26d.png";